import { api } from './authClient';

export function adminGet(path) {
  return api(`/api/admin${path}`);
}

export function adminSend(path, method, body) {
  return api(`/api/admin${path}`, {
    method,
    body: JSON.stringify(body),
  });
}

export function dollarsToCents(value) {
  const raw = String(value ?? '').trim();
  if (!/^\d{1,7}(\.\d{1,2})?$/.test(raw)) return null;
  const [whole, frac = ''] = raw.split('.');
  return Number(whole) * 100 + Number(frac.padEnd(2, '0'));
}

export function centsToDollars(cents) {
  const whole = Math.floor(Number(cents) / 100);
  const frac = String(Math.abs(Number(cents)) % 100).padStart(2, '0');
  return frac === '00' ? String(whole) : `${whole}.${frac}`;
}
